<template>
    <form class="action-form" :action="`/referrals/${referral.id}/remind`" @submit.prevent="submit()">
        <button class="action-btn" type="submit" :disabled="isSent || form.isSubmitted">
            <span v-if="isSent">Sent</span>
            <span v-else>Remind</span>
        </button>
    </form>
</template>
<script>

import Toast from '@/classes/Toast'
import Form from '@/classes/Form'

export default {

    props: ['referral'],

    data() {
        return {
            isSent: false,
            form: new Form(),
        }
    },

    methods: {
        submit() {
            this.form.post(`/referrals/${this.referral.id}/remind`)
                .then(response => {
                    this.isSent = true;
                    Toast.success('Reminder Sent')
                });
        }
    }
}
</script>
